const Delete = (props: any) => {
    return (
        <svg onClick={props.clickHandler} viewBox="0 0 24 24">
            <path fill="currentColor" d="M6,19A2,2 0 0,0 8,21H16A2,2 0 0,0 18,19V7H6V19M8,9H16V19H8V9M15.5,4L14.5,3H9.5L8.5,4H5V6H19V4H15.5Z" />
        </svg>
    )
}
const Pallete = (props: any) => {
    return (
        <svg onClick={props.clickHandler} viewBox="0 0 24 24">
            <path fill="currentColor" d="M17.5,12A1.5,1.5 0 0,1 16,10.5A1.5,1.5 0 0,1 17.5,9A1.5,1.5 0 0,1 19,10.5A1.5,1.5 0 0,1 17.5,12M14.5,8A1.5,1.5 0 0,1 13,6.5A1.5,1.5 0 0,1 14.5,5A1.5,1.5 0 0,1 16,6.5A1.5,1.5 0 0,1 14.5,8M9.5,8A1.5,1.5 0 0,1 8,6.5A1.5,1.5 0 0,1 9.5,5A1.5,1.5 0 0,1 11,6.5A1.5,1.5 0 0,1 9.5,8M6.5,12A1.5,1.5 0 0,1 5,10.5A1.5,1.5 0 0,1 6.5,9A1.5,1.5 0 0,1 8,10.5A1.5,1.5 0 0,1 6.5,12M12,3A9,9 0 0,0 3,12A9,9 0 0,0 12,21A1.5,1.5 0 0,0 13.5,19.5C13.5,19.11 13.35,18.76 13.11,18.5C12.88,18.23 12.73,17.88 12.73,17.5A1.5,1.5 0 0,1 14.23,16H16A5,5 0 0,0 21,11C21,6.58 16.97,3 12,3Z" />
        </svg>
    )
}
const Close = (props: any) => {
    return (
        <svg onClick={props.clickHandler} viewBox="0 0 24 24">
            <path fill="currentColor" d="M13.46,12L19,17.54V19H17.54L12,13.46L6.46,19H5V17.54L10.54,12L5,6.46V5H6.46L12,10.54L17.54,5H19V6.46L13.46,12Z" />
        </svg>
    )
}
const Reload = () => {
    return (
        <svg viewBox="0 0 24 24">
            <path fill="currentColor" d="M2 12C2 16.97 6.03 21 11 21C13.39 21 15.68 20.06 17.4 18.4L15.9 16.9C14.63 18.25 12.86 19 11 19C4.76 19 1.64 11.46 6.05 7.05C10.46 2.64 18 5.77 18 12H15L19 16H19.1L23 12H20C20 7.03 15.97 3 11 3C6.03 3 2 7.03 2 12Z" />
        </svg>
    )
}
const Sort = () => {
    return (
        <svg viewBox="0 0 512 512" >

<g transform="translate(0.000000,512.000000) scale(0.100000,-0.100000)" >
<path d="M2340 4705 l0 -215 1390 0 1390 0 0 215 0 215 -1390 0 -1390 0 0 -215z"/>
<path d="M467 4422 l-467 -467 152 -153 153 -152 212 212 213 213 0 -1515 0 -1515 -213 213 -212 212 -153 -153 -152 -152 468 -468 c257 -257 472 -467 477 -467 5 0 220 210 477 467 l468 468 -152 152 -153 153 -212 -212 -213 -213 0 1515 0 1515 213 -213 212 -212 153 153 152 152 -468 468 c-257 257 -472 467 -477 467 -6 0 -220 -210 -478 -468z"/>
<path d="M2340 3630 l0 -210 960 0 960 0 0 210 0 210 -960 0 -960 0 0 -210z"/>
<path d="M2340 2560 l0 -210 1390 0 1390 0 0 210 0 210 -1390 0 -1390 0 0 -210z"/>
<path d="M2340 1490 l0 -210 960 0 960 0 0 210 0 210 -960 0 -960 0 0 -210z"/>
<path d="M2340 415 l0 -215 1390 0 1390 0 0 215 0 215 -1390 0 -1390 0 0 -215z"/>
</g>
</svg>
    )
}


export { Delete, Pallete, Close, Reload, Sort }